import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ColorAlphaPipe } from './color-alpha.pipe';
import { ColorDirective } from './color.directive';
import {
  ContrastColorPipe,
  PreserveContrastColorPipe,
} from './contrast-color.pipe';
import { HighlightColorDirective } from './highlight-color.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ColorDirective,
    ContrastColorPipe,
    ColorAlphaPipe,
    HighlightColorDirective,
    PreserveContrastColorPipe,
  ],
  exports: [
    ColorDirective,
    ContrastColorPipe,
    ColorAlphaPipe,
    HighlightColorDirective,
    PreserveContrastColorPipe,
  ],
  providers: [ContrastColorPipe, PreserveContrastColorPipe],
})
export class ColorsModule {}
